import script from "./PrivacyPolicy.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrivacyPolicy.vue?vue&type=script&setup=true&lang=ts"

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=f524a82a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f524a82a"]])

export default __exports__